import { initializeSourcingSharedController } from '../initializeSourcingSharedController';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types/sharedSourcingStoreApi';
import { Channels } from 'generated-graphql/types';
import { SourcingInviteSubmitPayload } from 'modules/sourcing-shared/shared-stores/types';

type HandleSourcingSharedInviteSubmitControllerProps = {
  payload: SourcingInviteSubmitPayload;
  get: SharedSourcingStoreApi['getState'];
  set: SharedSourcingStoreApi['setState'];
};

export const handleSourcingSharedInviteSubmitController = async ({
  payload,
  get,
  set
}: HandleSourcingSharedInviteSubmitControllerProps) => {
  const {
    candidateBatch,
    customizeMessageFormData,
    jobInformationFormData,
    channelFormData,
    applicationFormData,
    editedOpeningMessage
  } = get();

  if (
    !candidateBatch?.id ||
    !customizeMessageFormData ||
    !jobInformationFormData ||
    !applicationFormData
  ) {
    return;
  }

  await initializeSourcingSharedController({
    candidateBatch,
    payload,
    customizeMessageFormData: {
      ...customizeMessageFormData,
      customTemplatedMessage:
        editedOpeningMessage || customizeMessageFormData.customTemplatedMessage
    },
    jobInformationFormData,
    channelFormData: channelFormData ?? {
      channel: Channels.Email
    },
    applicationFormData
  });

  set({
    step: 'SUCCESS',
    candidateBatch: candidateBatch
      ? {
          ...candidateBatch,
          customJobPostingUrl: applicationFormData.customJobPostingUrl
        }
      : null
  });
};
